/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, effect, OnInit, signal, viewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateUpdateViewComponent } from '../dialogue/state-update-view/state-update-view.component';
import { Node } from '../../explorer/node';
// import { DebugComponent } from '../states/debug/debug.component';
import { Usdm2Service } from '../../../services/ai/usdm2.service';
import { DbService } from '../../../services/db.service';
import { ObjectivesComponent } from '../states/objectives/objectives.component';
import { PropertiesComponent } from '../states/properties/properties.component';
import { PopulationComponent } from '../states/population/population.component';
import { EndpointsComponent } from '../states/endpoints/endpoints.component';
import { ElementsComponent } from '../states/elements/elements.component';
import { ArmsComponent } from '../states/arms/arms.component';
import { CreateStudyComponent } from '../states/create-study/create-study.component';
import { EpochsVisitsComponent } from '../states/epochs-visits/epochs-visits.component';
import { ActivitiesComponent } from '../states/activities/activities.component';
import { ScheduleOfActivitiesComponent } from '../states/schedule-of-activities/schedule-of-activities.component';
import { CriteriaComponent } from '../states/criteria/criteria.component';
import { SoaTablesComponent } from '../states/soa-tables/soa-tables.component';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule, CheckboxChangeEvent } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-extraction-mapping',
  imports: [
    CommonModule,
    StateUpdateViewComponent,
    DialogModule,
    CheckboxModule,
    FormsModule,
  ],
  templateUrl: './extraction-mapping.component.html',
  styleUrl: './extraction-mapping.component.css',
})
export class ExtractionMappingComponent implements OnInit {
  selectedStates = signal<string[]>([]);
  viewDlg = viewChildren<StateUpdateViewComponent>('viewDlg');
  currentState: string | null = null;
  isRunningState: boolean = false;
  spinning: boolean = false;
  dependencyDialogVisible: boolean = false;
  dependencyDependencies: string[] = [];
  dependencyStateName: string | null = null;
  allChecks: { allSelected: boolean; indeterminate: boolean } = {
    allSelected: false,
    indeterminate: false,
  };

  stopAi = signal<boolean>(false);

  constructor(private usdm: Usdm2Service, private db: DbService) {
    effect(() => {
      this.currentState = this.usdm.currentState();
      this.isRunningState = this.usdm.isRunningState();
      if (this.selectedStates().length === 0) {
        this.allChecks.allSelected = false;
        this.allChecks.indeterminate = false;
      }
      if (!this.usdm.isRunningState()) {
        this.spinning = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.usdm.publicOsbStudyId) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.states.unshift({
        name: 'CreateStudy',
        component: CreateStudyComponent as any,
      });
    }

    this.usdm.usdmSessionId$.subscribe(async (sessionId) => {
      console.log('Extraction mapping Session ID:', sessionId);
      if (sessionId) {
        this.updateSessionMessage(sessionId);
      }
    });
  }

  states = [
    // { name: 'Debug', component: DebugComponent },
    // { name: 'Debug2', component: null },
    // { name: 'Debug3', component: null },
    { name: 'Properties', component: PropertiesComponent },
    { name: 'Arms', component: ArmsComponent },
    { name: 'Population', component: PopulationComponent },
    { name: 'Objectives', component: ObjectivesComponent },
    { name: 'Endpoints', component: EndpointsComponent },
    { name: 'Elements', component: ElementsComponent },
    { name: 'Find SOA Tables', component: SoaTablesComponent, required: true },
    { name: 'Epochs & Visits', component: EpochsVisitsComponent },
    { name: 'Activities', component: ActivitiesComponent },
    {
      name: 'Schedule Of Activities',
      component: ScheduleOfActivitiesComponent,
    },
    { name: 'Criteria', component: CriteriaComponent },
    // { name: 'Download USDM', component: DownloadUsdmComponent, required: true }
  ];

  async updateSessionMessage(sessionId: string) {
    let data;
    try {
      data = await this.db.listUsdmStateHistories(sessionId);
      console.log('USDM state histories:', data);
    } catch (error) {
      console.error('Error fetching USDM state histories:', error);
    }

    if (data) {
      for (const item of data) {
        let messageToUser = '';
        let extractedData: object | null = null;
        // console.log(item.state, item.history)
        const states = this.usdm.states
        const state = Object.keys(states).find(state => state === item.state)
        // console.log(state)
        for (const history of item.history) {
          if (history.role === 'assistant') {
            const content = JSON.parse(history.content)
            // console.log(content.msg_to_user)
            messageToUser += "-  " + content.msg_to_user + "\n"
          } else if (history.type === 'OsbUploadResponse') {
            this.usdm.currentState.set(state!)
            this.usdm.setContentUpdate({
              type: 'OsbUploadResponse',
              success: history.success,
              message: history.message,
              data: history.data
            })
            if (history.success) {
              messageToUser += "-  " + `<span class="text-green-600 font-semibold">${history.message}</span>` + "\n"
            } else {
              messageToUser += "-  " + `<span class="text-red-400 font-semibold">${history.message}</span>` + "\n"
            }
          } else if (history.type === 'FinishResponse') {
            this.usdm.currentState.set(state!)
            this.usdm.setContentUpdate({
              type: 'FinishResponse',
              result: history.result
            })
            extractedData = history.result
            break;
          }
        }
        this.usdm.updateStateStatus(state!, 'completed', {
          aiThought: messageToUser,
          extractedData: extractedData || {}
        });
        // break;
      }
    }
  }

  get protocol(): Node | null {
    return this.usdm.protocol;
  }

  async extract(stateName: string, userMsg: string | null): Promise<void> {
    await this.usdm.runState(stateName, userMsg);
    // await this.usdm.dummyRunState(stateName);
    this.selectedStates.set(this.selectedStates().filter(s => s !== stateName));
  }

  getStateStatus(stateName: string): string | null {
    return this.usdm.states[stateName]?.status || null;
  }

  async extractAll() {
    // this.usdm.aiWriting.set(true);
    this.stopAi.set(true);
    this.selectedStates.set(
      this.states
        .map(state => state.name)
        .filter(name => this.selectedStates().includes(name))
    );
    console.log('selectedStates', this.selectedStates);

    for (const state of this.selectedStates()) {
      try {
        if (!this.stopAi()) {
          break;
        }
        const dialogComponent = this.viewDlg().find(
          component => component.state.name === state
        );
        await this.extract(state, null);
        if (dialogComponent && dialogComponent?.isVisible) {
          dialogComponent.toggleDialog();
        }
      } catch (error) {
        console.error('Error extracting state', state, error);
        if (
          error instanceof Error &&
          (error as any).cause?.code === 'STATE_DEPENDENCY_NOT_COMPLETED'
        ) {
          this.dependencyDialogVisible = true;
          this.dependencyDependencies = (error as any).cause.dependencies;
          this.dependencyStateName = (error as any).cause.stateName;
          console.error(
            'State dependencies not completed',
            this.dependencyDependencies
          );
          break;
        }
      }
    }
    this.stopAi.set(false);
  }

  stopExtraction() {
    this.spinning = true;
    this.stopAi.set(false);
    this.usdm.aiWriting.set(false);
  }

  onStateCheckboxChange(stateName: string) {
    if (this.selectedStates().includes(stateName)) {
      this.selectedStates.set(
        this.selectedStates().filter(state => state !== stateName)
      );
    } else {
      this.selectedStates.update(prev => [...prev, stateName]);
    }
    this.allChecks.allSelected = true;
    this.allChecks.indeterminate = true;
    if (this.selectedStates().length === this.states.length) {
      this.allChecks.allSelected = true;
      this.allChecks.indeterminate = false;
    }

    if (this.selectedStates().length === 0) {
      this.allChecks.allSelected = false;
      this.allChecks.indeterminate = false;
    }
  }

  selectAllStates(event: CheckboxChangeEvent) {
    console.log('Select all states event:', event, this.allChecks);
    if (this.allChecks.allSelected && !this.allChecks.indeterminate) {
      console.log('Selecting all states');
      // case 0 -> n
      this.selectedStates.set(this.states.map(state => state.name));
    } else {
      console.log('Deselecting all states');
      // case x -> 0
      this.allChecks.indeterminate = false;
      this.allChecks.allSelected = false;
      this.selectedStates.set([]);
    }
    // if (this.selectedStates.length === this.states.length) {
    //   this.selectedStates = [];
    // // } else if (indeterminate) {
    // //   this.selectedStates = []
    // } else {
    //   this.selectedStates = this.states.map(state => state.name);
    // }
  }

  addDependentStates() {
    this.usdm.aiWriting.set(false);
    this.usdm.isRunningState.set(false);
    this.usdm.currentState.set(null);
    this.selectedStates.update(prev => {
      prev.push(...this.dependencyDependencies);
      return prev;
    });
    this.dependencyDialogVisible = false;
  }
}
